import {Stack} from 'src/design/atoms/Stack';
import React from 'react';
import type {ISelectOption} from 'src/types/Form';
import {AuthenticationSection} from './sections/AuthenticationSection';
import {BadgeExpirationSection} from './sections/BadgeExpirationSection';
import {BannerSection} from './sections/BannerSection';
import {FeatureFlagsSection} from './sections/FeatureFlagsSection';
import {GeneralSection} from './sections/GeneralSection';
import {OtherSettingsSection} from './sections/OtherSettingsSection';

export interface InstanceOverviewTabProps {
  mode: 'create' | 'edit' | 'view';
  userGroupOptions: ISelectOption[];
  instanceId?: number;
}

export const InstanceOverviewTab: React.FC<InstanceOverviewTabProps> = ({
  mode,
  userGroupOptions,
}) => {
  return (
    <Stack gap="md" data-testid="instance-overview-tab">
      <GeneralSection mode={mode} />
      <FeatureFlagsSection mode={mode} />
      <AuthenticationSection mode={mode} userGroupOptions={userGroupOptions} />
      <BadgeExpirationSection mode={mode} />
      <OtherSettingsSection mode={mode} />
      <BannerSection mode={mode} />
    </Stack>
  );
};
